import type { MarkerCategory } from "../types/domain.types";

export const MARKER_CATEGORIES: MarkerCategory[] = [
  "CARRO",
  "CO2",
  "PQS",
  "RED",
  "ACETATO",
  "ESPUMA",
  "DUCHA",
];

export const MARKER_CATEGORY_LABEL: Record<MarkerCategory, string> = {
  CARRO: "Carro",
  CO2: "CO2",
  PQS: "PQS",
  RED: "RED",
  ACETATO: "Acetato",
  ESPUMA: "Espuma",
  DUCHA: "Ducha",
};

/**
 * Ruta absoluta del icono PNG por categoria.
 * Los archivos viven en /public/icons y se sirven en /icons/<X>.png.
 */
export const MARKER_CATEGORY_ICON: Record<MarkerCategory, string> = {
  CARRO: "/icons/Carro.png",
  CO2: "/icons/CO2.png",
  PQS: "/icons/PQS.png",
  RED: "/icons/RED.png",
  ACETATO: "/icons/ACETATO.png",
  ESPUMA: "/icons/ESPUMA.png",
  DUCHA: "/icons/DUCHA.png",
};
